export const CLEAR_COTTAGE = 'CLEAR_COTTAGE';

export const FETCH_COTTAGE_REQUEST = 'FETCH_COTTAGE_REQUEST';
export const FETCH_COTTAGE_SUCCESS = 'FETCH_COTTAGE_SUCCESS';
export const FETCH_COTTAGE_FAILURE = 'FETCH_COTTAGE_FAILURE';

export const CREATE_COTTAGE_REQUEST = 'CREATE_COTTAGE_REQUEST';
export const UPDATE_COTTAGE_REQUEST = 'UPDATE_COTTAGE_REQUEST';
export const UPDATE_COTTAGE_SUCCESS = 'UPDATE_COTTAGE_SUCCESS';
export const UPDATE_COTTAGE_FAILURE = 'UPDATE_COTTAGE_FAILURE';
export const UPDATE_COTTAGE_IDLE = 'UPDATE_COTTAGE_IDLE';

export const REMOVE_COTTAGE_REQUEST = 'REMOVE_COTTAGE_REQUEST';
export const REMOVE_COTTAGE_SUCCESS = 'REMOVE_COTTAGE_SUCCESS';
export const REMOVE_COTTAGE_FAILURE = 'REMOVE_COTTAGE_FAILURE';

export const LAST_MINUTE_DEALS_REQUEST = 'LAST_MINUTE_DEALS_REQUEST';
export const LAST_MINUTE_DEALS_SUCCESS = 'LAST_MINUTE_DEALS_SUCCESS';
export const LAST_MINUTE_DEALS_FAILURE = 'LAST_MINUTE_DEALS_FAILURE';
export const LAST_MINUTE_DEALS_DELETE = 'LAST_MINUTE_DEALS_DELETE';
export const LAST_MINUTE_DEALS_DELETE_SUCCESS = 'LAST_MINUTE_DEALS_DELETE_SUCCESS';
export const LAST_MINUTE_DEALS_CREATE = 'LAST_MINUTE_DEALS_CREATE';
export const LAST_MINUTE_DEALS_CREATE_SUCCESS = 'LAST_MINUTE_DEALS_CREATE_SUCCESS';

export const COTTAGE_VERIFICATION_REQUEST = 'COTTAGE_VERIFICATION_REQUEST';
export const COTTAGE_VERIFICATION_SUCCESS = 'COTTAGE_VERIFICATION_SUCCESS';
export const COTTAGE_VERIFICATION_FAILURE = 'COTTAGE_VERIFICATION_FAILURE';

export const CHANGE_COTTAGE_PRISTINE = 'CHANGE_COTTAGE_PRISTINE';
export const FETCH_COTTAGES_TAGS_REQUEST = 'FETCH_COTTAGES_TAGS_REQUEST';
export const FETCH_COTTAGES_TAGS_SUCCESS = 'FETCH_COTTAGES_TAGS_SUCCESS';
